module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/products-enable-crm.png"